import React from 'react'
import LinkedinVisibilitySelfAuditQuestions from './LinkedinVisibilitySelfAuditQuestions'

const LinkedinVisibilitySelfAuditExercise = ({ questions, section }) => {
  return (
    <div>
      <LinkedinVisibilitySelfAuditQuestions
        questions={questions}
        index={section}
      />
    </div>
  )
}

export default LinkedinVisibilitySelfAuditExercise
